
// const AppURL = 'http://192.168.2.14:3000';
const AppURL = 'https://octopus-app-56i3l.ondigitalocean.app';


//npm run build

export default AppURL;
